// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"style_headerContainer__m_boz","headingContainer":"style_headingContainer__nXNcd"};